import React from 'react';
import type { Editor } from '@tiptap/core';

export interface FontFamilyOption {
  label: string;
  value: string;
}

export interface FontFamilyPickerProps {
  editor: Editor;
  fontFamilies?: FontFamilyOption[];
}

const DEFAULT_FONT_FAMILIES: FontFamilyOption[] = [
  { label: 'Sans Serif', value: 'Arial, Helvetica, sans-serif' },
  { label: 'Serif', value: 'Georgia, Times New Roman, serif' },
  { label: 'Monospace', value: 'Monaco, Menlo, Courier New, monospace' },
  { label: 'Arial', value: 'Arial, sans-serif' },
  { label: 'Georgia', value: 'Georgia, serif' },
  { label: 'Times New Roman', value: 'Times New Roman, serif' },
  { label: 'Courier New', value: 'Courier New, monospace' },
  { label: 'Verdana', value: 'Verdana, sans-serif' },
  { label: 'Trebuchet MS', value: 'Trebuchet MS, sans-serif' },
];

export const FontFamilyPicker: React.FC<FontFamilyPickerProps> = ({
  editor,
  fontFamilies,
}) => {
  const families = fontFamilies || DEFAULT_FONT_FAMILIES;
  const currentFamily = editor.getAttributes('textStyle').fontFamily || '';

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    if (value === '') {
      editor.chain().focus().unsetFontFamily().run();
    } else {
      editor.chain().focus().setFontFamily(value).run();
    }
  };

  return (
    <select
      className="font-family-picker"
      value={currentFamily}
      onChange={handleChange}
      title="Font Family"
    >
      <option value="">Font</option>
      {families.map((family) => (
        <option key={family.value} value={family.value} style={{ fontFamily: family.value }}>
          {family.label}
        </option>
      ))}
    </select>
  );
};
